import { FormSelect } from "components/Forms/FormSelect";
import { WasteClassification } from "generated-graphql/graphql";
import { Control } from "react-hook-form";

import { prettyPrintWasteClassification } from "../../prettyPrintWasteClassification";

interface MergedWasteStreamClassificationInputProps {
  control: Control<any>;
}

export const MergedWasteStreamClassificationInput = ({
  control,
}: MergedWasteStreamClassificationInputProps) => {
  return (
    <FormSelect
      name="classification"
      label="Classification"
      hideErrors
      selectItems={Object.values(WasteClassification).map((value) => ({
        value,
        display: prettyPrintWasteClassification(value),
      }))}
      control={control}
      clearable={false}
    />
  );
};
